/**
 * Created by ori on 25/07/16.
 */
import 'babel-polyfill';

import React, {Component} from 'react'
import {Router, hashHistory, match} from 'react-router'
import routes from './js/routes'
import {render} from 'react-dom';
import {Provider, observer} from 'mobx-react';
import store from './js/store';
import App from './js/pages/App';
// import '../public/fonts/roboto/web fonts/index.css';
// import '../public/fonts/icomoon/style.css';

// var $ = require('jquery');
// window.jQuery = $;
// window.$ = $;


import { useRouterHistory } from 'react-router'
import { createHashHistory } from 'history'
// useRouterHistory creates a composable higher-order function
const appHistory = useRouterHistory(createHashHistory)({ queryKey: false })

match({history: appHistory, routes}, (error, redirectLocation, renderProps) => {
    render(
        <App>
            <Router {...renderProps} />
        </App>
        , document.querySelector('#root'));
});
require('../node_modules/bootstrap/dist/css/bootstrap.min.css')
require('../node_modules/bootstrap-material-design/dist/css/bootstrap-material-design.min.css');
require('./css/style.css');
require('./css/material_ui_custom.css');



// WEBPACK FOOTER //
// ./src/index.js